module.exports = __webpack_public_path__ + "img/inspect_2 - 副本.6485e084.png";